module.exports = [{
    title: "人员身份管理软件",
    id: 'a0',
    desc: '以人为核心，全周期、多维度人员身份智能管理，动作、姿态、视线等信息，集成强大的智能化算法和智能化设备，形成统一化人员管理软件系统。',
    img: [
        '1.png',
        '2.png',
    ],
    introduce: [

        {
            type: "html",
            class: 'd-a1',
            inner: `
                <p class="tit">系统简介</p>
                <p >● 以人为核心，多要素智能检测</p>
                <p >●  以场景为坐标，多点位接入</p>
                <p >●  人员身份+行为+定位，综合管控</p>
                <p >●  人员身份合规、人员轨迹合规、人员操作合规</p>
                <p >●  多种方式处置，科学有效</p>
                
            `
        },
        {
            type: "html",
            class: 'd-a2',
            inner: `
                <p class="tit">特点及优势</p>
                <p >●  高安全生物特征，杜绝冒名</p>
                <p >●  便捷高效，杜绝繁琐</p>
                <p > ●  划分区域权限，杜绝串岗</p>
                <p > ●  轨迹可追溯，杜绝托管</p>
            `
        },


    ],
},
{
    title: "洁净服全生命周期管理软件",
    id: 'a1',
    img: [
        '3.png',
        '4.png',
    ],
    desc: '洁净服管理系统是用于管理和跟踪洁净服的使用、清洗、维护和更换等活动的系统。洁净服是一种专门设计的服装，用于在洁净环境中（如医疗、实验室、电子生产等场所）工作时保持工作环境的洁净度和无菌性。洁净服管理系统的主要功能包括：',
    introduce: [

        {
            type: "html",
            class: 'd-b1',
            inner: `
            <p class="tit">系统简介</p>
        <p > ● 洁净服领用记录：系统可以记录每位员工领用洁净服的信息，包括领用时间、数量、员工姓名等，实现洁净服的个人化管理</p>
        <p > ● 洁净服清洗与维护：系统可以跟踪洁净服的清洗和维护情况，包括清洗时间、清洗方式、维护记录等，确保洁净服的清洁和无菌性</p>
        <p >●  洁净服效期管理：系统可以设定洁净服更换周期并提醒员工及时更换洁净服，避免过期使用或污染风险</p>
        <p >●  洁净服库存管理：系统可以实时监控洁净服库存量，提醒及时补充，确保员工有足够的洁净服可使用</p>
        <p > ● 审批流程：系统能够实现洁净服领用和清洗等活动的审批流程管理，提高管理效率和规范性</p>
        <p >● 数据报表分析：系统可以生成洁净服使用情况、清洗记录等报表，为管理者提供数据分析和决策依据</p>

       
        `,
        },
        {
            type: "html",
            class: 'd-b2',
            inner: `
        
        <p class="tit">特点及优势</p>
        <p > ● 提高工作效率：洁净服管理系统可以减少人工管理成本，提高工作效率，减少因管理不善而导致的错误和问题</p>
        <p > ● 强化洁净环境控制：通过洁净服管理系统的规范管理，可以加强洁净环境的控制，提高工作环境的洁净度和无菌性</p>
        <p > ● 提升安全性：洁净服管理系统可以提醒员工及时更换洁净服，降低受污染的风险，提升工作场所的安全性</p>
        <p > ● 数据统计与分析：系统能够生成洁净服使用数据报表，帮助管理者对洁净服使用情况进行分析，发现问题并及时修正</p>
        <p > ● 规范管理流程：洁净服管理系统能够规范洁净服的使用和清洗流程，确保管理流程的规范性和科学性</p>
        `,
        }
    ],
},
{
    title: "人员行为管理软件",
    id: 'a2',
    img: [
        '5.png',
        '6.png',
    ],
    desc: '以智能行为分析算法为核心，对人员的行为、动作进行分析理解，利用AIGC、计算机视觉、自然语言处理等人工智能最新技术，最大程度的解决相关行业管理难的问题。',
    introduce: [

        {
            type: "html",
            class: 'd-c1',
            inner: `
        <p class="tit">系统简介</p>
        <p >● 系统通过AI视觉技术和高性能智能算法，实现主动违规动作检测、动作姿态检测，极大提高企业的应急处置及管理能力</p>
       
        `
        },
        {
            type: "html",
            class: 'd-c2',
            inner: `
       
        <p class="tit">特点及优势</p>
        <p >● 违规行为及时告警，保证人身及环境安全</p>
        <p >● 报警画面直观展示，提高人员管理效率</p>
        `
        }
    ],
},
{
    title: "电子实验记录本（ELN)",
    id: 'a3',
    img: [
        '7.png',
        '8.png',
    ],
    desc: '针对实验室管理混乱、实验数据流失率高、安全管理难度大、分享传承困难等业务痛点，以设备智能化管理、项目智能管理、实验数据管理、实验物料管理为基础，形成真实、完整、可追溯的电子实验记录本系统。',
    introduce: [

        {
            type: "html",
            class: 'd-d1',
            inner: `
        <p class="tit">系统简介</p>
        <p > ● ELN系统的主要功能是替代传统的纸质实验记录本，将实验数据、实验过程和实验结果等信息以电子形式进行记录和管理 </p>
       

        `
        },
        {
            type: "html",
            class: 'd-d2',
            inner: `
       
        <p class="tit">特点及优势</p>
        <p >● 电子化记录：ELN系统将实验数据、实验过程、实验结果等信息以电子形式进行记录，避免了传统纸质记录本的繁琐和易丢失的问题</p>
        <p >● 可追踪性：ELN系统能够追踪整个实验流程，包括实验计划、实验执行、数据记录等步骤，确保实验数据的准确性和可信度</p>
        <p >● 数据共享与协作：ELN系统支持多人共享实验数据，团队成员可以方便地查看、编辑和共享数据，促进团队合作和交流</p>
        <p >● 数据分析与报告：ELN系统具有数据分析功能，可以对实验数据进行统计、分析和可视化，生成报告和图表，帮助科研人员更好地理解数据和结果</p>
        <p >● 数据安全性：ELN系统提供数据加密、权限控制和备份功能，保障实验数据的安全性，防止数据泄霁和丢失</p>
        <p >● 提升效率：ELN系统能够简化实验记录流程，减少手工操作，提高工作效率，让科研人员能够专注于实验设计和数据分析</p>

        `
        },
    ],
},
{
    title: "人工智能算法平台",
    id: 'a4',
    img: [
        '9.png',
        '10.png',
        '11.png',
    ],
    desc: '人工智能研发平台是复杂的AI体系和复杂的业务体系之间的一座桥梁，能够将业务需求通过机器学习、自然语言处理、视觉技术、智能决策技术等人工智能手段融合到业务管理中，同时能够有效保护数据安全、节省人力成本',
    introduce: [

        {
            type: "html",
            class: 'd-e1',
            inner: `
        <p class="tit">平台介绍</p>
        <p >● 以自然语言的方式，通过语音文本与智能系统进行交互，实现从信息系统到智能助理的巨大跨越 </p>
     

        `
        },
        {
            type: "html",
            class: 'd-e2',
            inner: `
        <p class="tit">平台优势</p>
        <p >● 系统能够通过与实验室相关设备的对接，实时获取科研人员的操作记录并上传系统</p>

        `
        },
        {
            type: "html",
            class: 'd-e3',
            inner: `

    

        <p class="tit">行业推广</p>
        <p >● 全过程电子记录，减少人力操作</p>
        <p >● 数据真实、安全、可靠</p>

        `
        }
    ],
},

];